export default function () {
	return {
		sidebarIsOpen: false,

		init() {
			this.attachEvents()
		},

		attachEvents() {
			window.addEventListener('sidebar:toggle', () => {
				this.toggleSidebar()
			})

			new ResizeObserver(() => {
				if (
					!this.sidebarIsOpen
					|| window.innerWidth < 1024
				) {
					return
				}

				this.toggleSidebar()
			}).observe(this.$root)
		},

		toggleSidebar() {
			this.sidebarIsOpen = !this.sidebarIsOpen

			if (!this.sidebarIsOpen) {
				document.body.classList.remove('has-overlay')
			}
			else {
				document.body.classList.add('has-overlay')
			}
		},
	}
}
